<template>
  <div class="rules-panel">
    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :hide-default-footer="true"
      :disable-sort="true"
    >
      <template v-slot:cell="{ column, row }">
        <BaseDashboardTableCell
          :column="column"
          :row="row"
        >
          <span
            v-if="column.key in (row.results || {})"
            class="rules-panel__icon"
            :class="row.results[column.key] ? 'rules-panel__icon--ok' : 'rules-panel__icon--no'"
          >
            {{ row.results[column.key] ? '✓' : '✕' }}
          </span>
          <span v-else>{{ row[column.key] }}</span>
        </BaseDashboardTableCell>
      </template>
    </BaseDashboardTable>
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import BaseDashboardTableCell from './BaseDashboardTableCell.vue'

export default {
  name: 'BaseRulesPanel',
  components: { BaseDashboardTable, BaseDashboardTableCell },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.rules-panel {
  &__icon {
    font-size: 1rem;
    font-weight: 700;

    &--ok {
      color: var(--v-success-base);
    }

    &--no {
      color: var(--v-error-base);
    }
  }
}
</style>
